// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"mq-z","slideIn":"nq-z"};